// Shared currency helpers.
// The site-wide default currency is configurable by the admin
// (Settings → General → Currency) and exposed via PublicSettingsContext as
// `settings.default_currency`. Records that carry their own `currency` (plans,
// payments) should pass it explicitly; aggregates without a currency fall back
// to the configured default.

export const CURRENCY_SYMBOLS = { EUR: '€', BRL: 'R$', USD: '$', GBP: '£' };

export const SUPPORTED_CURRENCIES = [
  { code: 'EUR', label: 'EUR (€)' },
  { code: 'BRL', label: 'BRL (R$)' },
  { code: 'USD', label: 'USD ($)' },
  { code: 'GBP', label: 'GBP (£)' },
];

const LOCALE_BY_CURRENCY = { EUR: 'en-IE', BRL: 'pt-BR', USD: 'en-US', GBP: 'en-GB' };

export const currencySymbol = (code = 'EUR') => CURRENCY_SYMBOLS[code] || `${code} `;

/**
 * Format a numeric amount as currency.
 * Falls back to a symbol + fixed-decimal string for unknown ISO codes so the UI
 * never throws on an unexpected currency value.
 */
export const formatMoney = (amount, currency = 'EUR', options = {}) => {
  const code = (currency || 'EUR').toUpperCase();
  const value = Number(amount) || 0;
  try {
    return new Intl.NumberFormat(LOCALE_BY_CURRENCY[code] || 'en-IE', {
      style: 'currency',
      currency: code,
      ...options,
    }).format(value);
  } catch {
    const digits = options.maximumFractionDigits ?? 2;
    return `${currencySymbol(code)}${value.toFixed(digits)}`;
  }
};
